import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const approveEmergencyPto = async (
  org_id: any,
  p_approver_org_user_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/users/p_approver/${p_approver_org_user_id}/approve_e_pto`;
  return await PATCH({ apiUri: path, data })
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
